import isURL from 'validator/es/lib/isURL';

export const isUrlValid = (url) => typeof url === 'string' && (url === '' || isURL(url));

export const addProtocol = (url) => {
  if (!url || url.match(/:\/\//)) return url || '';
  return `https://${url}`;
};

export const __ = {
  reload: () => {
    /* istanbul ignore next */
    window.location.reload();
  },
  setLocation: (location) => {
    /* istanbul ignore next */
    window.location = location;
  },
  getUri: () => window.location.href,
  getLocationSearch: () => window.location.search,
  isDeepLink: () => window.location.pathname && !['/', '/login', '/new-password', '/forgot-password'].includes(window.location.pathname),
  isMockingNavianceLogin: () => (
    /* istanbul ignore next */
    process.env.MOCK_NAVIANCE_LOGIN
  ),
};

/* eslint-disable no-console */
export function createReducer(initialState, reducerMap) {
  return (state = initialState, action) => {
    const reducer = reducerMap[action.type];

    return reducer ?
      reducer(state, action.payload) :
      state;
  };
}

// allows to have reducers work on the same potion of a state object.
// usefull when splitting reducers under different components
export function reduceReducers(...reducers) {
  return (previous, current) =>
    reducers.reduce(
      (p, r) => r(p, current),
      previous,
    );
}

/**
 * Returns true if browser supports localStorage, false otherwise.
 * @ignore
 */
const _supportsLocalStorage = () => {
  try {
    const supportsLocalStorage = 'localStorage' in window && window.localStorage;
    /* istanbul ignore else */
    if (supportsLocalStorage) {
      window.localStorage.setItem('storageTest', '');
      window.localStorage.removeItem('storageTest');
    }
    return supportsLocalStorage;
  } catch (e) {
    return false;
  }
};

const _supportsSessionStorage = () => {
  try {
    const supportsSessionStorage = 'sessionStorage' in window && window.sessionStorage;
    /* istanbul ignore else */
    if (supportsSessionStorage) {
      window.sessionStorage.setItem('storageTest', '');
      window.sessionStorage.removeItem('storageTest');
    }
    return supportsSessionStorage;
  } catch (e) {
    return false;
  }
};

export const _saveItem = (cacheLocation, key, obj) => {
  if (cacheLocation === 'localStorage') {
    if (!_supportsLocalStorage()) {
      console.log('Local storage is not supported');
      return false;
    }
    localStorage.setItem(key, obj);
    return true;
  }

  // Default as session storage
  if (!_supportsSessionStorage()) {
    console.log('Session storage is not supported');
    return false;
  }

  sessionStorage.setItem(key, obj);
  return true;
};

/**
 * Searches the value for the given key in the cache
 * @ignore
 */
export const _getItem = (cacheLocation, key) => {
  if (cacheLocation === 'localStorage') {
    if (!_supportsLocalStorage()) {
      console.log('Local storage is not supported');
      return null;
    }
    return localStorage.getItem(key);
  }

  // Default as session storage
  if (!_supportsSessionStorage()) {
    console.log('Session storage is not supported');
    return null;
  }
  return sessionStorage.getItem(key);
};

export const _expiresIn = (expires) => (
  Math.round(new Date().getTime() / 1000.0) + parseInt(expires, 10)
);

export function _deserialize(query) {
  query = query.replace('?', '');
  const pl = /\+/g; // Regex for replacing addition symbol with a space
  const search = /([^&=]+)=([^&]*)/g;
  const decode = (s) => (decodeURIComponent(s.replace(pl, ' ')));
  const obj = {};
  let match = search.exec(query);
  while (match) {
    obj[decode(match[1])] = decode(match[2]);
    match = search.exec(query);
  }
  return obj;
}

export function isDeepLink() {
  return __.isDeepLink();
}

export function reload() {
  __.reload();
}

/* istanbul ignore next */
export function postMessage(contentWindow, postText, targetOrigin) {
  contentWindow.postMessage(postText, targetOrigin);
}

// convenience helper to encapsulate global.window.location.href attr
// useful for mocks/stubs while unit testing
export function getUri() {
  return __.getUri();
}

// convenience setter to encapsulate global.window.location attr
// useful for mocks/stubs while unit testing
export function setLocation(location) {
  __.setLocation(location);
}

// convenience getter to encapsulate global.window.location.search attr
// useful for mocks/stubs while unit testing
export function getLocationSearch() {
  return __.getLocationSearch();
}

// convenience helper to encapsulate process.env.MOCK_NAVIANCE_LOGIN env var
// useful for mocks/stubs while unit testing
export function isMockingNavianceLogin() {
  return __.isMockingNavianceLogin();
}

export const escapeCsvCommands = (value) => {
  // The following must not be allowed as the first character of a field exported to CSV -> ["=", "+", "-", "@"].
  const startsWithCommandCharacters = /^(=|\+|-|@)/.test(value);
  if (startsWithCommandCharacters) return `'${value}`;
  return value;
};
